import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import { bayerDarkTheme, bayerLightTheme } from '../theme/bayerTheme';

const bayerLightThemeExtension = ThemeBlueprint.make({
  name: 'bayer-light',
  params: {
    theme: {
      id: 'light',
      title: 'Bayer Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={bayerLightTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

const bayerDarkThemeExtension = ThemeBlueprint.make({
  name: 'bayer-dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Bayer Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={bayerDarkTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [bayerLightThemeExtension, bayerDarkThemeExtension],
});
